var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSize2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 83,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.272,
    width: 97.862,
    height: 82.245,
    rx: 2,
    fill: "#DFE0E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 16h58.3v50.858H20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECF0",
    d: "M23.721 19.722h50.858v4.962H23.721zm0 8.682h34.732v4.962H23.721zm0 9.924h50.858v11.164H23.721z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#223143",
    d: "M23.721 53.214h50.858v8.683H23.721z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize2);
export default __webpack_public_path__ + "static/media/size-2.bec8a6c051caad3d4c3fcd2c85baae73.svg";
export { ForwardRef as ReactComponent };